import {mapState,mapMutations} from 'vuex';
import {roll_detail, roll_join, roll_player_page} from "@/api";
import {conversion, GetItemDuration} from "@/tool";

import Avatar from '@/components/avatar';
import Picture from '@/components/picture';
import Button from '@/components/button';
import CustomButton from '@/partials/custom_button';
import { Modal, use_modal } from '@/components/modal';
import InteractivePanel from '@/components/interactive_panel';
import Award from '@/components/award';
import countDownModel from "@/components/countDown";
export default {
    name: "rollDetail",
    components: {
        'c-avatar': Avatar,
        'c-picture': Picture,
        'c-button': Button,
        'p-custom-button': CustomButton,
        'c-modal': Modal,
        'c-interactive-panel': InteractivePanel,
        'c-award': Award,
        "c-countDown": countDownModel,
    },

    filters: {
        conversion,
        GetItemDuration
    },


    data(){ return {
        player_cur_tab:0,
        detailData: {
            Items: [],
            desc: "",
            time: "",
            joined: false,
            hasPassword: false,
            itemCount: 2,
            userCount: 0,
            winnerCount: 0,
            players: [],
            winners: [],
            state: 0,
            totalSeconds: 0,
            totalPrice:0,
        },

        counterTime: {
            timeId: 0, //计时器id
            day: '00',
            hour: '00',
            min: '00',
            sec: '00'
        },


        playerPage: {
            playerIndex: 1,
            playerTotalPage: 0,
            playerTotal: 0,
            prizeIndex: 1,
            prizeTotal: 0
        },
        /** 密码房 模态框 */
        password_room_modal:{
            flag:false,
            pwd:'',
        },

        }
    },

    computed: {
        ...mapState(['user'])
    },


    created() {
        this.getList()
    },

    methods: {
        ...mapMutations(['setInfo','setPayModal','setloginModal']),
        listenScroll(e) {  //监听滚动
            /*let ele = e.srcElement ? e.srcElement : e.target;
            if (ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 20) { //监听滚动到div底部

                if(this.playerPage.playerIndex < this.playerPage.playerTotalPage){
                    this.playerPage.playerIndex++;
                    this.pageOfPlayer();
                }
            }*/
        },
        getList(){
            roll_detail({id: this.$route.params.id}).then(res => {
                if(res.data.code === 0){
                    clearInterval(this.counterTime.timeId)
                    this.detailData = res.data.data;
                    this.detailData.players = this.detailData.players.slice(0,30);
                    this.playerPage = {
                        playerIndex: 1,
                        playerTotalPage: this.detailData.userCount/30,
                        playerTotal: this.detailData.userCount,
                        prizeIndex: 1,
                        prizeTotal: this.detailData.winnerCount
                    }

                    if(this.detailData.state === 0 && this.detailData.totalSeconds > 0){
                        this.sumTime(this.detailData.totalSeconds)

                        this.counterTime.timeId = setInterval(() => {
                            let time = --this.detailData.totalSeconds;

                            if(time <= 0){
                                clearInterval(this.counterTime.timeId);
                                this.getList()
                            } else {
                                this.sumTime(time)
                            }
                        }, 1000)
                    }
                }
            })
        },

        sumTime(time){
            const day = Math.floor(time/(60*60*24));
            const hour = Math.floor(time/(60*60)%24);
            const min = Math.floor(time/60%60);
            const sec = Math.floor(time%60);

            this.counterTime.day = `0${ day }`.slice(-2);
            this.counterTime.hour = `0${ hour }`.slice(-2);
            this.counterTime.min = `0${ min }`.slice(-2);
            this.counterTime.sec = `0${ sec }`.slice(-2);

            //console.log(this.counterTime);
        },

        enterPasswordRollRoom(){
            if(!this.user.nickname){
                return this.$store.commit('setloginModal', true)
            }

            if(this.detailData.hasPassword){
                 this.password_room_modal.flag = true;
            }
        },

        enterRollRoom(){
            if(!this.user.nickname){
                return this.$store.commit('setloginModal', true)
            }

            if(this.detailData.hasPassword && this.password_room_modal.pwd === ''){
                return this.$toast.error('请输入口令,口令不能为空')
            }

            roll_join({id: this.$route.params.id, password: this.password_room_modal.pwd}).then(res => {
                if(res.data.code === 0){
                    this.$toast.success(res.data.msg);
                    this.password_room_modal.flag = false;
                    this.getList();

                    if(this.detailData.hasPassword){
                        this.password_room_modal.flag=false;
                    }

                } else {
                    this.$toast.error(res.data.msg)

                    if(res.data.msg.indexOf('充值') > -1){
                        this.setPayModal(true);
                    }
                }
            })
        },

        pageOfPlayer(){
            roll_player_page({id: this.$route.params.id, current: this.playerPage.playerIndex ,size:100}).then(res => {
                if(res.data.code === 0){

                    let pageUserdata = res.data.data.data;

                    pageUserdata.forEach(item => {
                        this.detailData.players.push(item);
                    });
                    
                    this.playerPage.playerIndex = res.data.data.pageNumber;
                    
                    this.playerPage.playerTotal = this.detailData.numOfPlayers = res.data.data.totalItems;
                }
            })
        },
    }
};